import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const skuEbayEnrichmentSocket = io(`${socketBaseUrl}/sku-ebay-enrichment`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default skuEbayEnrichmentSocket;
